"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Accordion = void 0;
var react_1 = __importDefault(require("react"));
var css_1 = require("@emotion/css");
var uuid_1 = require("uuid");
var design_system_foundations_1 = require("@contrast-security-inc/design-system-foundations");
var design_system_typography_1 = require("@contrast-security-inc/design-system-typography");
var AccordionStyles_1 = require("./AccordionStyles");
var messages = __importStar(require("../translations"));
exports.Accordion = react_1.default.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, setIsOpen = _a.setIsOpen, title = _a.title, _c = _a.initialIsOpen, initialIsOpen = _c === void 0 ? false : _c, _d = _a.showBorder, showBorder = _d === void 0 ? true : _d, _e = _a.arrowPlacement, arrowPlacement = _e === void 0 ? 'right' : _e, testId = _a.testId, rest = __rest(_a, ["children", "className", "isOpen", "setIsOpen", "title", "initialIsOpen", "showBorder", "arrowPlacement", "testId"]);
    var selectedTheme = (0, design_system_foundations_1.useThemeContext)().selectedTheme;
    var formatMessage = (0, design_system_foundations_1.useLocalizationContext)().formatMessage;
    var contentRef = react_1.default.useRef(null);
    var _f = react_1.default.useState(isOpen || initialIsOpen), isOpenInternal = _f[0], setIsOpenInternal = _f[1];
    var titleId = react_1.default.useRef("".concat((0, uuid_1.v4)(), "-accordion-title-id")).current;
    var contentId = react_1.default.useRef("".concat((0, uuid_1.v4)(), "-accordion-content-id")).current;
    var isAccordionOpen = isOpen || isOpenInternal;
    var toggleOpen = function () {
        setIsOpen === null || setIsOpen === void 0 ? void 0 : setIsOpen(!isOpen);
        setIsOpenInternal(!isOpenInternal);
    };
    return (react_1.default.createElement("div", __assign({ className: (0, css_1.cx)(AccordionStyles_1.containerCss, 'ds-accordion', isAccordionOpen && 'open', className), "data-testid": testId, ref: ref }, rest),
        react_1.default.createElement("div", { "aria-controls": contentId, "aria-expanded": isAccordionOpen, className: (0, AccordionStyles_1.headerCss)(arrowPlacement), onClick: toggleOpen, onKeyDown: function (event) {
                if (event.key === ' ') {
                    event.preventDefault();
                }
                if (event.key === 'Enter' || event.key === ' ') {
                    toggleOpen();
                }
            }, role: "button", tabIndex: 0, id: titleId, "data-testid": "".concat(testId, "-accordion-header") },
            react_1.default.createElement(design_system_typography_1.Text, { font: "bodyStrong" }, typeof title === 'function' ? title({ isOpen: isAccordionOpen }) : title),
            react_1.default.createElement(design_system_foundations_1.IconCaretUp, { className: (0, AccordionStyles_1.iconCss)(isAccordionOpen, arrowPlacement), color: (0, design_system_foundations_1.getThemeValue)(selectedTheme, { light: 'neutral80', dark: 'neutral50' }) })),
        react_1.default.createElement("div", { className: AccordionStyles_1.contentCss },
            react_1.default.createElement("div", { "aria-label": formatMessage(messages, 'accordion_content'), className: (0, css_1.cx)((0, AccordionStyles_1.contentInnerCss)(isAccordionOpen)), ref: contentRef, id: contentId, "data-testid": "".concat(testId, "-accordion-content") }, children({ isOpen: isAccordionOpen }))),
        showBorder && (react_1.default.createElement("span", { className: (0, AccordionStyles_1.borderCss)(isAccordionOpen, selectedTheme), "data-testid": "".concat(testId, "-accordion-border") }))));
});
exports.Accordion.displayName = 'Accordion';
